import React, { useState } from "react";
import { Content, CriticalButton, IconDiv } from "./styles";
import TrendDown from "../../../assets/icons/TrendDown";
import Help from "./HelpDialog";
import CriticalDialog from "./CriticalDialog";
import { handleValidation } from "../../../pages/FlowPane/utils";

const ActiveCritical = ({ elements, critical, setCritical, value }) => {
  const removedTypes = ["customMark", "customText", "CustomNote"];

  const visible = elements.filter(
    (item) =>
      item.data.status !== "outscoped" && !removedTypes.includes(item.type)
  );

  const [help, setHelp] = useState(false);

  const validation = () => handleValidation(visible);
  const handleClick = () => {
    if (!critical) {
      if (validation()) setCritical();
    } else {
      setCritical();
    }
  };

  return (
    <>
      <Content>
        <CriticalButton critical={critical} onClick={handleClick}>
          <IconDiv critical={critical}>
            <TrendDown />
          </IconDiv>
        </CriticalButton>
        {help && <Help setHelp={() => setHelp(false)} />}
        {critical && value && (
          <CriticalDialog value={value} setCritical={setCritical} />
        )}
      </Content>
    </>
  );
};

export default ActiveCritical;
